import React, {useState, useRef} from "react";
import styles from './styles.module.scss';
import Button from "../../../components/Button";
import GotoTrangleSvg from "../../../components/svg/GotoTrangleSvg";
import Marquee from "react-fast-marquee";
import jumpToChat from "../../../utils/jumpToChat";

export default function XiniuChat() {

  const hints = [
    "国内有哪些eVTOL赛道的公司？",
    "2025年有哪些具身智能赛道的公司获得大额融资？",
    "2025年主要投资人工智能的基金有哪些？",
    "近半年成立的母基金有哪些？",
    "2025年出资次数排名前10的政府引导基金有哪些？",
    "红杉中国管理的类型为创业投资基金的备案基金有多少家？",
    "今年投资事件数量最多的投资机构是哪家？",
    "哪些上市公司通过基金间接投资了宇树科技？",
    "最近一周哪些机器人领域企业获得了融资？",
    "最近两个月投资国内人形机器人次数最多的投资机构有哪些？",
    "今日的最新投融资事件信息",
    "请简单介绍软银中国这家机构，包括投资公司数量及覆盖的行业。",
    "近五年在上海有过投资的lp有哪些？"
  ]

  const inputRef = useRef<HTMLInputElement>(null);
  const [inputStatus, setInputStatus] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('列出上个月国内投资次数排名前十的机构和机构类型');

  const handleChangeInput = (e) => {
    setInputValue(e.target.value);
  }

  const handleSubmitInput = () => {
    jumpToChat(inputValue)
  }

  const handleKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      jumpToChat(inputValue.trim());
    }
  };

  return (
    <section className={styles.xiniuChat}>
      <h1>科创AI，数据引领未来</h1>
      <h2>AI原生打造，全新一代科创金融数据引擎</h2>
      <div className={styles.input}
           onClick={() => {
             setInputStatus(true);
             setTimeout(() => {
               inputRef.current?.focus();
             }, 0); // 延迟是为了等待 input 渲染完成
           }}
      >
        <div className={styles.content}>
          <div>
            <span className={styles.tips}>AI科创企业问答</span>
            {inputStatus?
              <input  ref={inputRef}
                      className={styles.chat_input}
                      value={inputValue}
                      onChange={handleChangeInput}
                      onKeyDown={handleKeydown}
                      placeholder={'请输入问题'}
              />
              :
              <span className={styles.placeholder}>{inputValue}</span>
            }
          </div>
          <Button className={styles.btn} onClick={handleSubmitInput}>
            <img src="./static-official/images/send.svg"/>
            获取回答
          </Button>
        </div>
      </div>
      <div>
        <Marquee pauseOnHover autoFill>
          {hints.map((h, i) => i%2 === 0
            ?
            <div className={styles.hintsItem} key={`xiniu_chat_slider_${i}`} onClick={() => {jumpToChat(h)}}>
              {h}
              <GotoTrangleSvg />
            </div>
            :
            null
          )}
        </Marquee>
        <Marquee pauseOnHover autoFill>
          {hints.map((h, i) => i%2 === 1
            ?
            <div className={styles.hintsItem} key={`xiniu_chat_slider_${i}`} onClick={() => {jumpToChat(h)}}>
              {h}
              <GotoTrangleSvg />
            </div>
            :
            null
          )}
        </Marquee>
      </div>
    </section>
  )
}
